import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';

// project-import
import { ThemeMode } from 'config';

import logo from 'assets/images/logo.png';
import { useHospitalDetails } from 'api/cutsom-hooks';
import { pickHospitalLogo } from 'utils/gst';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }) {
  const theme = useTheme();
  const hospitalData = useHospitalDetails();
  const configuredLogo = pickHospitalLogo(hospitalData, logo, ['app_logo']);
  return (
     <img src={theme.palette.mode === ThemeMode.DARK ? configuredLogo : configuredLogo} alt="Hospital" width="200" />
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
